<template>
  <div class="search-input" v-if="showDialog">
    <el-dialog
      :show-close="false"
      width="400px"
      :visible.sync="showDialog">
      <header class="search-input_dialog-header" slot="title">
        <span class="search-input-label">选择查询</span>
        <i @click="showDialog = false" class="iconfont iconguanbi"></i>
      </header>
      <div class="search-input_dialog-content">
        <div class="q-list">
          <ul id="queryTree" class="ztree"></ul>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small"
          type="primary"
          @click="select">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import store from '../../../../store'
  import { selectMykDataSearch } from "../../../../api";

  let fn
  let treeObj = null

  export default {
    name: "index",
    data () {
      return {
        loadingData: false,
        showDialog: false,
        list: [],
        currentParamsObj: {},
      }
    },
    methods: {
      show (data) {
        fn = data.fn
        selectMykDataSearch({
          token: store.state.user.userId,
          type: data.type,
          pageNum: 1,
          pageSize: 1000
        }).then(res => {
          this.list = res.data
          this.$nextTick(() => {
            this.initTree()
          })
        })
        this.showDialog = true
      },
      initTree () {
        let that = this
        function zTreeOnClick (event, treeId, treeNode) {
          that.currentLevel = treeNode.level
          const {id, name, searchJson, itype, userId, sessionId, createDate, createDateMin, createDateMax, delFlag, parentId, newRecord} = treeNode
          that.currentParamsObj = {
            id, name, searchJson, itype, userId, sessionId, createDate, createDateMax, createDateMin, delFlag, parentId, newRecord
          }
        }
        let setting = {
          simpleData: {
            enable: true,
            idKey: 'id'
          },
          data: {
            key: {
              name: 'name',
              children: "childList",
              isParent: 'parent'
            }
          },
          callback: {
            onClick: zTreeOnClick,
          }
        }
        let el = $('#queryTree')
        treeObj = $.fn.zTree.init(el, setting, this.list);
        treeObj.expandAll(true)
      },
      select () {
        if (!this.currentParamsObj.id || this.currentLevel <= 0) {
          this.$message.warning('请选择一个查询')
          return
        }
        fn(this.currentParamsObj.searchJson)
        this.showDialog = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .q-list{
    height: 276px;
    overflow: auto;
    border: 1px solid #e1e1e1;
    li{
      padding: 0 20px;
      line-height: 40px;
      color: #333333;
      font-size: 20px;
      cursor: pointer;
      &.active{
        color: #fff;
        background-color: #2B8DDE;
      }
    }
  }
</style>
